import {
  Space,
  Table,
  Button,
  notification,
  Modal,
  Row,
  Typography,
  Image,
  Input,
  DatePicker,
} from "antd";
import type { ColumnsType } from "antd/lib/table";
import { SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import styles from "./quizzes.module.css";
import { FC, useEffect, useState } from "react";
import { GetQuizzes_getQuizzes } from "../../__generated__/gql-types/GetQuizzes";
import { useQuizzes } from "../../hooks/useQuizzes";

const { Text } = Typography;
const { Search } = Input;

const Quizzes: FC = () => {
  const { deleteQuiz, loading: isLoading, quizzes } = useQuizzes();
  const [dataSource, setdataSource] = useState<GetQuizzes_getQuizzes[] | null>(
    []
  );
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [idQuiz, setIdQuiz] = useState<string>("");

  useEffect(() => {
    setdataSource(quizzes);
  }, [quizzes]);

  const showModal = (id: string) => {
    setIsModalVisible(true);
    setIdQuiz(id);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = async () => {
    try {
      await deleteQuiz(idQuiz);
      setIsModalVisible(false);
    } catch {
      notification["error"]({
        message: "Eliminación Erronea",
        description: "El quiz no pudo ser eliminado!",
        placement: "top",
        duration: 3,
      });
    }
  };

  const columns: ColumnsType<GetQuizzes_getQuizzes> = [
    {
      align: "center",
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    { align: "center", title: "Título", dataIndex: "title", key: "title" },
    {
      title: "Publicado",
      dataIndex: "publish",
      key: "publish",
      render: (record) => {
        return (
          <>
            <Row style={{ marginTop: 5 }}>
              {record === 1 ? (
                <Text type="success">Publicado</Text>
              ) : (
                <Text type="danger">No publicado</Text>
              )}
            </Row>
          </>
        );
      },
    },
    {
      align: "center",
      title: "Acciones",
      key: "acciones",
      render: (_, record) => {
        return (
          <Space size={15} style={{ fontSize: 19 }}>
            <Link to={`/quizzes/${record.id}`} state={record.id}>
              <Button icon={<SearchOutlined />}>Editar</Button>
            </Link>
            <Button
              onClick={() => {
                showModal(record.id);
              }}
              danger
            >
              Eliminar
            </Button>
          </Space>
        );
      },
    },
  ];

  const onSearch = (value: string) => {
    if (value === "") {
      setdataSource(quizzes);
    } else {
      if (dataSource) {
        const filteredData: GetQuizzes_getQuizzes[] = dataSource.filter(
          (data) => data.title?.includes(value)
        );
        setdataSource(filteredData);
      }
    }
  };

  const onSearchId = (value: string) => {
    if (value === "") {
      setdataSource(quizzes);
    } else {
      if (dataSource) {
        const filteredData: GetQuizzes_getQuizzes[] = dataSource.filter(
          (data) => data.id === value
        );
        setdataSource(filteredData);
      }
    }
  };

  return (
    <div className={styles.container}>
      <h1>Quizzes</h1>
      <div className={styles.newQuizzesContainer}>
        <Space direction="vertical" style={{ marginRight: 20 }}>
          <Search
            placeholder="Buscar por id"
            onSearch={onSearchId}
            enterButton
          />
        </Space>
        <Space direction="vertical" style={{ marginRight: 20 }}>
          <Search
            placeholder="Buscar por título"
            onSearch={onSearch}
            enterButton
          />
        </Space>
        <Button type="primary" danger>
          <Link to="/quizzes/new">Nuevo Quiz</Link>
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={dataSource ?? []}
        loading={isLoading}
        rowKey={(record) => record.id}
      />
      <Modal
        title="Eliminar Quiz"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>¿Desea eliminar el quiz?</p>
      </Modal>
    </div>
  );
};

export default Quizzes;
